import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  IconButton,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Backdrop,
  CircularProgress,
  Alert,
  Autocomplete,
  LinearProgress,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CloseIcon from "@mui/icons-material/Close";
import { categoryService } from "../services/categoryService";
import { useDispatch, useSelector } from "react-redux";
import { addCategory, deleteCategory } from "../redux/actions/categorysActions";
import { addPlacesCategory } from "../redux/actions/placesCategoryActions";
import { CategoryUpdate } from "./UI/reusable-components/CategoryComponents/CategoryUpdate";
import useAlert from "../hooks/useAlert";
import CategoryMatchingModal from "./UI/reusable-components/CategoryComponents/CategoryMatchingModal";
import EditIcon from "@mui/icons-material/Edit";
import SyncIcon from "@mui/icons-material/Sync";
import { AiOutlinePartition } from "react-icons/ai";
import CategoryProductEdithModal from "./UI/reusable-components/CategoryComponents/CategoryProductEdithModal";
import { getMarketPlaces } from "../redux/actions/marketplacesActions";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import ecommercePlaceService from "../services/ecommercePlaceService";
import marketplacesService from "../services/marketplacesService";
import outWardService from "../services/outWardService";
import iaService from "../services/iaService";
import { unwrapThunkList } from "../utils/helpers";
const flattenCategories = (categories, prefix = "") => {
  return categories.reduce((acc, category) => {
    const categoryName = category.name;
    acc.push({
      id: category.id,
      name: categoryName,
      vatRate: category.vatRate,
      parentId: category.parent?.id,
    });
    if (category.inverseParent?.length > 0) {
      acc = acc.concat(flattenCategories(category.inverseParent, categoryName));
    }
    return acc;
  }, []);
};

// Bizim kategorimizin üst kategori zincirini ("Çocuk > Üst Giyim > Hırka") çıkarır - backend artık
// her kategori için parent navigasyonunu dolduruyor (CategoryGetSpecification)
const buildOurCategoryPath = (category) => {
  const segments = [];
  let current = category;
  while (current?.name) {
    segments.unshift(current.name);
    current = current.parent;
  }
  return segments.join(" > ");
};

// CategoryMatchingModal'daki flattenMarketPlaceCategories ile aynı - pazaryerinin kategori
// ağacını (marka/isim farketmeksizin tüm pazaryerleri için aynı şekilde) düz listeye çevirir
const flattenMarketPlaceCategories = (categories, parentPath = [], level = 0) => {
  let flatList = [];

  const recurse = (categoryList, currentPath, currentLevel) => {
    for (const category of categoryList) {
      const label = category.name ?? category.Name;
      const fullPath = [...currentPath, label];
      const children = category.categories ?? category.Categories ?? [];
      if (label != null) {
        flatList.push({
          id: category.id ?? category.Id,
          name: label,
          path: fullPath.join(" > "),
          level: currentLevel,
          isLeaf: children.length === 0,
        });
      }
      if (children.length > 0) {
        recurse(children, fullPath, currentLevel + 1);
      }
    }
  };

  recurse(categories, parentPath, level);

  return flatList;
};

// AI adaylarını hazırlar: pazaryerinden gelen kategorileri hiç ellemeden, sadece leaf
// (alt kategorisi olmayan) olanları olduğu gibi AI'a gönderiyoruz. Başka hiçbir
// daraltma/isim-eşleştirme kuralı yok - doğru cevabı yanlışlıkla eleyebiliyordu.
const buildAiCandidates = (options) => {
  return options.filter((option) => option?.isLeaf);
};

export const Categorys = () => {
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [selectedKdv, setSelectedKdv] = useState(null);
  const [showSubCategories, setShowSubCategories] = useState({});
  const [searchTerm, setSearchTerm] = useState(null);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [openDeleteErrorModal, setOpenDeleteErrorModal] = useState(false);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const [openDialogUpdate, setOpenDialogUpdate] = useState(false);
  const [selectedCategoryForEdit, setSelectedCategoryForEdit] = useState(null);
  const [page, setPage] = useState(1);
  // Backend zaten PageSize parametresini destekliyor, sadece hiç gönderilmiyordu - veri çok
  // olduğunda kullanıcı sayfa başına daha fazla kategori getirtebilsin diye seçilebilir yaptık
  const [pageSize, setPageSize] = useState(10);
  const [openModal, setOpenModal] = useState(false);
  const [modalCategory, setModalCategory] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setloading] = useState(false);
  const [openProductCategoryModal, setOpenProductCategoryModal] =
    useState(false);

  const [allPlaces, setAllPlaces] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState([]);

  // AI ile toplu kategori eşleştirme (modal akışı: pazaryeri seç -> önizle + onay -> çalıştır -> özet)
  const [aiModalOpen, setAiModalOpen] = useState(false);
  const [aiModalStep, setAiModalStep] = useState("select"); // select | preview | running | done
  const [aiModalPlace, setAiModalPlace] = useState(null);
  const [aiPreviewLoading, setAiPreviewLoading] = useState(false);
  const [aiUnmatchedList, setAiUnmatchedList] = useState([]);
  const [aiSelectedIds, setAiSelectedIds] = useState([]);
  const [aiConsentChecked, setAiConsentChecked] = useState(false);
  const [aiMatching, setAiMatching] = useState(false);
  const [aiProgress, setAiProgress] = useState({ current: 0, total: 0 });
  const [aiSummary, setAiSummary] = useState(null);

  const [importModalOpen, setImportModalOpen] = useState(false);
  const [selectedEcommerce, setSelectedEcommerce] = useState("");
  const [selectedVatRate, setSelectedVatRate] = useState("");
  const [importLoading, setImportLoading] = useState(false);
  const [importResultModal, setImportResultModal] = useState(false);
  const [importResult, setImportResult] = useState({
    success: false,
    message: "",
  });
  const ecommerceList = allPlaces.filter((p) => p.type === "ecommerce");
  const vatRates = [0, 1, 8, 10, 18, 20];

  const handleOpenProductCategoryModal = (category) => {
    setModalCategory(category);
    setOpenProductCategoryModal(true);
  };
  const handleCloseProductCategoryModal = () => {
    setModalCategory(null);
    setOpenProductCategoryModal(false);
  };

  const handleOpenModal = (category) => {
    setModalCategory(category);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setModalCategory(null);
    setOpenModal(false);
  };

  useEffect(() => {
    if (selectedCategoryForEdit) {
      setOpenDialogUpdate(true);
    }
  }, [selectedCategoryForEdit]);

  const handleEditCategory = (data) => {
    setSelectedCategoryForEdit(data);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchPlatforms = async () => {
      try {
        const [marketResponse, ecommerceResponse] = await Promise.all([
          dispatch(getMarketPlaces()),
          ecommercePlaceService.getEcommercePlaceAccountsApi(authUserId, token),
        ]);

        // E-ticaret platformlarını tekrarsız olarak al
        const ecommerceData = ecommerceResponse.data?.data?.data || [];
        const uniqueEcommercePlaces = Array.from(
          new Set(ecommerceData.map((item) => item.ecommercePlaceName))
        ).map((name) => {
          const firstItem = ecommerceData.find(
            (item) => item.ecommercePlaceName === name
          );
          return {
            id: firstItem.ecommercePlaceId,
            name: name,
            type: "ecommerce",
          };
        });

        const marketList = unwrapThunkList(marketResponse);
        const combinedData = [
          ...marketList.map((item) => ({
            ...item,
            type: "marketplace",
          })),
          ...uniqueEcommercePlaces,
        ];

        setAllPlaces(combinedData);
      } catch (err) {
        console.error("Platform fetch error:", err);
      }
    };
    fetchPlatforms();
  }, [dispatch]);
  const fetchCategories = async (pageNumber = 1) => {
    try {
      const placeId = {
        marketPlaceId:
          selectedPlace?.type == "marketplace" ? selectedPlace?.id : 0,
        ecommercePlaceId:
          selectedPlace?.type != "marketplace" ? selectedPlace?.id : 0,
      };
      setloading(true);
      const response = await categoryService.getCategoriesApi(
        token,
        pageNumber,
        searchTerm,
        authUserId,
        placeId,
        false,
        pageSize
      );
      const fetchedCategories = response.data?.data?.data;
      setTotalCount(response.data?.data?.recordsTotal);

      const categoriesTree = buildCategoryTree(fetchedCategories);
      setCategories(categoriesTree);
      setFilteredCategories(categoriesTree);
      setloading(false);
    } catch (error) {
      setloading(false);
      console.error("Kategoriler alınırken bir hata oluştu:", error);
    }
  };

  const buildCategoryTree = (categories) => {
    const processCategory = (category) => {
      return {
        ...category,
        subCategories: category.inverseParent?.map(processCategory) || [],
      };
    };

    return categories
      ?.map(processCategory)
      .filter((category) => !category.parent);
  };

  useEffect(() => {
    fetchCategories(page);
  }, [page, pageSize]);

  const handlePageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleCategoryChange = (e) => {
    const selectedCategoryName = e.target.value;
    setSelectedCategoryName(selectedCategoryName);
    const selectedCategory = flattenedCategories.find(
      (category) => category.name === selectedCategoryName
    );
    setSelectedCategory(selectedCategory);
  };
  const { showSuccessAlertCategoryAdd, showErrorAlertCategoryAdd } = useAlert();
  const handleCreate = async () => {
    if (newCategory.trim() === "") {
      alert("Lütfen geçerli bir kategori girin.");
      return;
    }
    if (selectedKdv == null) {
      alert("Lütfen KDV oranı seçinn.");
      return;
    }

    const categoryData = {
      name: newCategory,
      vatRate: selectedKdv,
      userId: authUserId,
      createTime: new Date(),
      updateTime: new Date(),
      ia: true,
      parentId: selectedCategory?.id || null,
    };

    try {
      await dispatch(addCategory(categoryData, token));
      await fetchCategories();
      setNewCategory("");
      setSelectedKdv("");
      setSelectedCategoryName("");
      setSelectedCategory(null);
      showSuccessAlertCategoryAdd();
    } catch (error) {
      showErrorAlertCategoryAdd();
    }
  };

  const handleDeleteDialogOpen = (categoryId, isRootCategory) => {
    setCategoryToDelete({ id: categoryId, isRootCategory });
    setOpenDeleteDialog(true);
  };

  const handleUpdateDialogOpen = (categoryId) => {
    setCategoryToDelete({ categoryId });
    setOpenDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setOpenDeleteDialog(false);
    setCategoryToDelete(null);
  };

  const handleDelete = async () => {
    try {
      await dispatch(deleteCategory(categoryToDelete.id, token));
      await fetchCategories();
      setOpenDeleteDialog(false);
      setCategoryToDelete(null);
    } catch (error) {
      console.error("Kategori silinirken hata oluştu:", error);
      setOpenDeleteDialog(false);
      setOpenDeleteErrorModal(true);
    }
  };

  const toggleSubCategories = (categoryName) => {
    setShowSubCategories((prev) => ({
      ...prev,
      [categoryName]: !prev[categoryName],
    }));
  };

  // CategoryMatchingModal.createRequestBody ile aynı - outWardService.fetchCategory için gerekli
  const createOutWardRequestBody = (selectedPlaceName, marketAccounts, ecomAccounts) => {
    const marketPlaceSettings = marketAccounts
      .filter((account) => account.marketPlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        marketPlaceId: account.marketPlaceId || 0,
        marketPlaceName: account.marketPlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    const ecommercePlaceSettings = ecomAccounts
      .filter((account) => account.ecommercePlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));

    return {
      userId: 0,
      marketPlaceSetting: marketPlaceSettings,
      ecommercePlaceSettings,
      startDate: new Date().toISOString(),
      endDate: new Date().toISOString(),
    };
  };

  const handleOpenAiModal = () => {
    setAiModalOpen(true);
    setAiModalStep("select");
    setAiModalPlace(null);
    setAiUnmatchedList([]);
    setAiSelectedIds([]);
    setAiConsentChecked(false);
    setAiSummary(null);
    setAiProgress({ current: 0, total: 0 });
  };

  const handleCloseAiModal = () => {
    if (aiMatching) return; // eşleştirme sürerken modal kapatılamaz
    const shouldRefresh = aiModalStep === "done";
    setAiModalOpen(false);
    setAiModalStep("select");
    setAiModalPlace(null);
    setAiUnmatchedList([]);
    setAiSelectedIds([]);
    setAiConsentChecked(false);
    setAiSummary(null);
    if (shouldRefresh) {
      fetchCategories(page);
    }
  };

  // Seçilen pazaryerine göre eşleşmemiş kategorileri listeleyip önizleme adımına geçer
  const handleAiModalPlaceNext = async () => {
    if (!aiModalPlace?.id) return;

    setAiPreviewLoading(true);
    try {
      // fetchCategories'deki ile aynı şekil: aiModalPlace'in kendisi değil,
      // {marketPlaceId, ecommercePlaceId} objesi backend filtresini tetikliyor.
      // Bunu unutursak backend "eşleşmemiş" filtresini hiç uygulamıyor, tüm kategoriler geliyor.
      const placeIdFilter = {
        marketPlaceId: aiModalPlace?.type === "marketplace" ? aiModalPlace?.id : 0,
        ecommercePlaceId: aiModalPlace?.type !== "marketplace" ? aiModalPlace?.id : 0,
      };
      const ourCategoriesRes = await categoryService.getCategoriesApi(
        token,
        1,
        null,
        authUserId,
        placeIdFilter,
        true
      );
      // Backend (CategoryGetSpecification) her kategoriyi ağaç seviyesine bakmaksızın TEK TEK
      // "bu pazaryerine eşleşmemiş mi" diye filtreliyor - dönen düz liste zaten tam olarak
      // istediğimiz set. Ama her kayıt ayrıca kendi inverseParent'inde TÜM alt ağacını da
      // taşıyor (alt kategoriler eşleşmiş olsa bile) - bu yüzden ağacı hiç açmadan, backend'in
      // verdiği düz listeyi olduğu gibi kullanmalıyız; flatten/tree-build edersek zaten eşleşmiş
      // alt kategoriler de listeye karışır.
      const ourUnmatchedCategories = (ourCategoriesRes?.data?.data?.data ?? []).map(
        (category) => ({
          id: category.id,
          name: category.name,
          // "Hırka" gibi tek başına belirsiz olabilecek isimler için üst kategori zinciri
          path: buildOurCategoryPath(category),
        })
      );
      setAiUnmatchedList(ourUnmatchedCategories);
      setAiSelectedIds(ourUnmatchedCategories.map((category) => category.id)); // varsayılan: tümü seçili
      setAiModalStep("preview");
    } catch (error) {
      console.error("Eşleşmemiş kategoriler alınırken hata oluştu:", error);
      setAiSummary({ error: true });
      setAiModalStep("preview");
    } finally {
      setAiPreviewLoading(false);
    }
  };

  const handleToggleAiCategory = (categoryId) => {
    setAiSelectedIds((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const handleToggleAiSelectAll = () => {
    setAiSelectedIds((prev) =>
      prev.length === aiUnmatchedList.length ? [] : aiUnmatchedList.map((category) => category.id)
    );
  };

  // Onay sonrası asıl AI eşleştirme döngüsü - sadece işaretli kategoriler üzerinde çalışır
  const handleAiMatchRun = async () => {
    const categoriesToMatch = aiUnmatchedList.filter((category) =>
      aiSelectedIds.includes(category.id)
    );

    if (!aiModalPlace?.id || categoriesToMatch.length === 0) return;

    setAiModalStep("running");
    setAiMatching(true);
    setAiSummary(null);
    setAiProgress({ current: 0, total: categoriesToMatch.length });

    try {
      const platformType = aiModalPlace.type === "marketplace" ? "marketplace" : "ecommerce";

      const [marketAccountsRes, ecomAccountsRes] = await Promise.all([
        marketplacesService.getMarketPlacesAccountsApi(authUserId, token),
        ecommercePlaceService.getEcommercePlaceAccountsApi(authUserId, token),
      ]);

      const marketAccounts = marketAccountsRes?.data?.data?.data ?? [];
      const ecomAccounts = ecomAccountsRes?.data?.data?.data ?? [];

      // Pazaryerinin tüm kategori ağacı - tek seferde çekilip her kategori için tekrar kullanılır
      const requestBody = createOutWardRequestBody(aiModalPlace.name, marketAccounts, ecomAccounts);
      const targetTree = await outWardService.fetchCategory(
        aiModalPlace.name,
        requestBody,
        token,
        platformType
      );
      const targetFlatCategories = flattenMarketPlaceCategories(targetTree);

      let matched = 0;
      let failed = 0;

      for (let i = 0; i < categoriesToMatch.length; i++) {
        const ourCategory = categoriesToMatch[i];

        try {
          const candidates = buildAiCandidates(targetFlatCategories);

          if (candidates.length === 0) {
            failed++;
          } else {
            const aiResult = await iaService.match(
              ourCategory.path || ourCategory.name,
              JSON.stringify(candidates.map((c) => ({ id: c.id, name: c.name }))),
              token
            );

            if (aiResult?.id) {
              const matchingData = {
                Id: 0,
                MarketPlaceId: platformType === "marketplace" ? aiModalPlace.id : null,
                EcommercePlaceId: platformType === "ecommerce" ? aiModalPlace.id : null,
                CategoryId: ourCategory.id,
                MarketPlaceCategoryId: aiResult.id,
                MarketPlaceCategoryName: aiResult.name,
                CreateDate: new Date().toISOString(),
                UpdateDate: new Date().toISOString(),
                IA: true,
              };

              await dispatch(addPlacesCategory(matchingData, token));
              matched++;
            } else {
              failed++;
            }
          }
        } catch (error) {
          console.error("AI eşleştirme sırasında hata:", ourCategory, error);
          failed++;
        }

        setAiProgress({ current: i + 1, total: categoriesToMatch.length });
      }

      setAiSummary({ matched, failed, total: categoriesToMatch.length });
      setAiModalStep("done");
    } catch (error) {
      console.error("AI toplu eşleştirme başlatılırken hata oluştu:", error);
      setAiSummary({ error: true });
      setAiModalStep("done");
    } finally {
      setAiMatching(false);
    }
  };

  const handleFilter = (e) => {
    // const searchValue = e.target.value.toLowerCase();
    // setSearchTerm(searchValue);
    fetchCategories(page);
    // if (!searchValue) {
    //   setFilteredCategories(categories);
    //   return;
    // }

    // const filterCategoryTree = (categories) => {
    //   return categories.reduce((acc, category) => {
    //     const matchesSearch = category.name.toLowerCase().includes(searchValue);
    //     const filteredSubCategories = category.subCategories ?
    //       filterCategoryTree(category.subCategories) : [];

    //     if (matchesSearch || filteredSubCategories.length > 0) {
    //       acc.push({
    //         ...category,
    //         subCategories: filteredSubCategories
    //       });
    //     }
    //     return acc;
    //   }, []);
    // };

    // const filtered = filterCategoryTree(categories);

    // setFilteredCategories(filtered);
  };

  const flattenedCategories = flattenCategories(categories);

  useEffect(() => {
    setTotalPages(Math.ceil(totalCount / pageSize));
  }, [totalCount, pageSize]);
  const renderCategories = (categories) => {
    return categories.map((category) => (
      <Box
        key={category.id}
        sx={{
          marginBottom: 1,
          padding: { xs: 0.5, sm: 1 },
          border: "1px solid #ddd",
          borderRadius: 2,
          backgroundColor: "#ffffff",
          boxShadow: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 0 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <IconButton
              onClick={() => toggleSubCategories(category.name)}
              sx={{ marginRight: 2 }}
              disabled={!category.subCategories?.length}
            >
              {category.subCategories?.length
                ? showSubCategories[category.name]
                  ? "↓"
                  : "→"
                : "-"}
            </IconButton>
            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
                fontSize: { xs: "0.9rem", sm: "1rem" },
              }}
            >
              {category.name}{" "}
              {category.vatRate ? `(KDV: %${category.vatRate})` : ""}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "wrap",
              justifyContent: { xs: "center", sm: "flex-end" },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <Button
              variant="outlined"
              onClick={() => handleOpenProductCategoryModal(category)}
              sx={{
                borderRadius: 2,
                border: "1px solid #1F1B45",
                color: "#1F1B45",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                padding: { xs: "8px 12px", sm: "10px 20px" },
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: { xs: "120px", sm: "auto" },
                "&:hover": {
                  backgroundColor: "#F3F3F3",
                  border: "1px solid #2C285A",
                  color: "#2C285A",
                },
              }}
              startIcon={<AiOutlinePartition />}
            >
              Ürün Ata
            </Button>

            <Button
              variant="outlined"
              onClick={() => handleOpenModal(category)}
              sx={{
                borderRadius: 2,
                border: "1px solid #1F1B45",
                color: "#1F1B45",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                padding: { xs: "8px 12px", sm: "10px 20px" },
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: { xs: "120px", sm: "auto" },
                "&:hover": {
                  backgroundColor: "#F3F3F3",
                  border: "1px solid #2C285A",
                  color: "#2C285A",
                },
              }}
              startIcon={<SyncIcon />}
            >
              Eşleştir
            </Button>

            <Button
              variant="outlined"
              onClick={() => handleEditCategory(category)}
              sx={{
                borderRadius: 2,
                border: "1px solid #1F1B45",
                color: "#1F1B45",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                padding: { xs: "8px 12px", sm: "10px 20px" },
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: { xs: "120px", sm: "auto" },
                "&:hover": {
                  backgroundColor: "#F3F3F3",
                  border: "1px solid #2C285A",
                  color: "#2C285A",
                },
              }}
              startIcon={<EditIcon />}
            >
              Düzenle
            </Button>

            <Button
              variant="outlined"
              onClick={() => handleDeleteDialogOpen(category.id, true)}
              sx={{
                borderRadius: 2,
                border: "1px solid #1F1B45",
                color: "#1F1B45",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                padding: { xs: "8px 12px", sm: "10px 20px" },
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: { xs: "120px", sm: "auto" },
                "&:hover": {
                  backgroundColor: "#F3F3F3",
                  border: "1px solid #2C285A",
                  color: "#2C285A",
                },
              }}
              startIcon={<DeleteIcon />}
            >
              Sil
            </Button>
          </Box>
        </Box>
        {showSubCategories[category.name] &&
          category.subCategories?.length > 0 && (
            <Box sx={{ marginTop: 2, marginLeft: { xs: 1, sm: 3 } }}>
              {renderCategories(category.subCategories)}
            </Box>
          )}
      </Box>
    ));
  };

  // İmport API çağrısı
  const handleImport = async () => {
    if (!selectedEcommerce || !selectedVatRate) {
      setImportResult({
        success: false,
        message: "Lütfen tüm alanları doldurun.",
      });
      setImportResultModal(true);
      return;
    }
    setImportLoading(true);
    try {
      // E-ticaret ve marketplace ayarlarını al
      const [ecommerceResponse, marketPlaceResponse] = await Promise.all([
        ecommercePlaceService.getEcommercePlaceAccountsApi(authUserId, token),
        marketplacesService.getMarketPlacesAccountsApi(authUserId, token),
      ]);

      // Seçilen e-ticaret platformunun adını bul
      const selectedEcommerceData = ecommerceResponse.data?.data?.data?.find(
        (item) => item.ecommercePlaceId === selectedEcommerce
      );
      const ecommerceName = selectedEcommerceData?.ecommercePlaceName;

      // Marketplace ayarlarını formatla
      const marketPlaceSettings = Array.isArray(marketPlaceResponse?.data?.data)
        ? marketPlaceResponse.data.data
        : marketPlaceResponse?.data?.data?.data || [];

      const formattedMarketPlaceSettings = marketPlaceSettings.map(
        (setting) => ({
          id: setting?.id || 0,
          userId: setting?.userId || authUserId,
          marketPlaceId: setting?.marketPlaceId || 0,
          marketPlaceName: setting?.marketPlaceName || "",
          valueId: setting?.valueId || "",
          value: setting?.value || "",
          createDate: setting?.createDate || new Date().toISOString(),
          updateDate: setting?.updateDate || new Date().toISOString(),
          ia: true,
        })
      );

      // Tüm e-ticaret platform ayarlarını al
      const ecommerceSettings = ecommerceResponse.data?.data?.data?.map(
        (setting) => ({
          id: setting.id,
          userId: setting.userId,
          ecommercePlaceId: setting.ecommercePlaceId,
          ecommercePlaceName: setting.ecommercePlaceName,
          value: setting.value,
          valueId: setting.valueId,
          createDate: setting.createDate,
          updateDate: setting.updateDate,
          ia: true,
        })
      );

      const body = {
        marketPlaceSetting: formattedMarketPlaceSettings,
        ecommercePlaceSettings: ecommerceSettings,
        vatRate: Number(selectedVatRate),
      };

      console.log(
        "Import API isteği gönderiliyor. Body:",
        JSON.stringify(body, null, 2)
      );

      const importResponse = await axios.post(
        `https://v2api.pazaryericonverter.com/Workload/Category/${ecommerceName}/ImportCategory`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setImportResult({
        success: true,
        message: "Kategori aktarımı başarıyla başlatıldı!",
      });
      setImportResultModal(true);
      setImportModalOpen(false);
      setSelectedEcommerce("");
      setSelectedVatRate("");
    } catch (err) {
      console.error("Import error detayları:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        headers: err.response?.headers,
        config: err.config,
      });
      setImportResult({
        success: false,
        message: "Aktarım sırasında hata oluştu!",
      });
      setImportResultModal(true);
    }
    setImportLoading(false);
  };

  // İmport modalı açıldığında allPlaces'i logla
  useEffect(() => {
    if (importModalOpen) {
      console.log("allPlaces:", allPlaces);
    }
  }, [importModalOpen, allPlaces]);

  return (
    <Box sx={{ width: "100%", padding: { xs: 0.5, sm: 1 } }}>
      <Box
        sx={{
          padding: { xs: 2, sm: 3 },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          mt: { xs: 2, sm: 4 },
          mb: { xs: 2, sm: 3 },
          ml: { xs: 0, sm: 1 },
          backgroundColor: "#F7F9FC",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          gap: { xs: 2, sm: 0 },
        }}
      >
        {/* Başlık */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{ width: 4, height: 24, backgroundColor: "#1F1B45", mr: 1 }}
          />
          <Typography
            variant="h6"
            sx={{
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              fontWeight: "bold",
              color: "#333",
              fontSize: { xs: "1rem", sm: "1.25rem" },
            }}
          >
            Kategori Ağacı
          </Typography>
        </Box>
        {/* İçeri Aktar butonu ve açıklama */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexDirection: { xs: "column", sm: "row" },
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#666",
              fontStyle: "italic",
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            E-ticaret sitelerinden kategorilerinizi kolayca içeri
            aktarabilirsiniz
          </Typography>
          <Button
            variant="contained"
            color="primary"
            fullWidth={false}
            sx={{ width: { xs: "100%", sm: "auto" } }}
            onClick={() => setImportModalOpen(true)}
          >
            İçeri Aktar
          </Button>
        </Box>
      </Box>
      <Divider sx={{ marginBottom: 1 }} />
      {/* Kategori Ekleme Formu */}
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: { xs: 2, sm: 5 },
          borderRadius: 2,
          boxShadow: 2,
          marginBottom: 3,
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
          }}
        >
          <Autocomplete
            size="small"
            sx={{ flex: { xs: "none", sm: 4 } }}
            options={[
              { id: null, name: "Ana Kategori Olarak Ekle" },
              ...flattenedCategories,
            ]}
            getOptionLabel={(option) => option?.name ?? ""}
            isOptionEqualToValue={(option, value) =>
              (option?.id ?? null) === (value?.id ?? null)
            }
            value={
              selectedCategory ?? { id: null, name: "Ana Kategori Olarak Ekle" }
            }
            onChange={(_, newValue) => {
              const cat = newValue?.id != null ? newValue : null;
              setSelectedCategory(cat);
              setSelectedCategoryName(cat ? cat.name : "");
            }}
            renderInput={(params) => (
              <TextField {...params} label="Üst Kategori" placeholder="Kategori ara..." />
            )}
          />
          <TextField
            size="small"
            label="Eklenecek Kategori"
            variant="outlined"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            sx={{ flex: { xs: "none", sm: 2 } }}
          />
          <FormControl sx={{ flex: { xs: "none", sm: 1 } }} size="small">
            <InputLabel>KDV Oranı</InputLabel>
            <Select
              value={selectedKdv}
              onChange={(e) => setSelectedKdv(e.target.value)}
              label="KDV Oranı"
            >
              <MenuItem value={0}>%0</MenuItem>
              <MenuItem value={1}>%1</MenuItem>
              <MenuItem value={8}>%8</MenuItem>
              <MenuItem value={10}>%10</MenuItem>
              <MenuItem value={18}>%18</MenuItem>
              <MenuItem value={20}>%20</MenuItem>
            </Select>
          </FormControl>
          <Button
            variant="contained"
            onClick={handleCreate}
            sx={{
              borderRadius: 18,
              backgroundColor: "#1F1B45",
              color: "#FFFFFF",
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.875rem",
              padding: "10px 20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              height: "100%",
              flex: { xs: "none", sm: 1 },
              boxShadow: "0 4px 8px rgba(31, 27, 69, 0.3)",
              "&:hover": {
                backgroundColor: "#2C285A",
                boxShadow: "0 6px 12px rgba(31, 27, 69, 0.4)",
              },
            }}
          >
            Kategori Ekle
          </Button>
        </Box>
      </Box>

      {/* Yapay Zeka ile Kategori Eşleştirme - öne çıkan banner */}
      <Box
        sx={{
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          gap: 2,
          p: { xs: 2, sm: 2.5 },
          mb: 2.5,
          borderRadius: 2,
          background: "linear-gradient(135deg, #1565c0 0%, #1e88e5 55%, #42a5f5 100%)",
          boxShadow: "0 4px 14px rgba(21, 101, 192, 0.35)",
          color: "#fff",
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <AutoAwesomeIcon
            sx={{
              fontSize: 32,
              flexShrink: 0,
              "@keyframes aiIconPulse": {
                "0%, 100%": { opacity: 1, transform: "scale(1)" },
                "50%": { opacity: 0.55, transform: "scale(1.2)" },
              },
              animation: "aiIconPulse 1.7s ease-in-out infinite",
            }}
          />
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
              Yapay Zeka ile Kategori Eşleştirme
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.92 }}>
              Bir pazaryeri seçin, eşleşmemiş tüm kategorileriniz otomatik eşleştirilsin.
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          onClick={handleOpenAiModal}
          startIcon={<AutoAwesomeIcon />}
          sx={{
            backgroundColor: "#fff",
            color: "#1565c0",
            fontWeight: 700,
            px: 3,
            borderRadius: 2,
            textTransform: "none",
            whiteSpace: "nowrap",
            width: { xs: "100%", sm: "auto" },
            flexShrink: 0,
            "@keyframes aiButtonGlow": {
              "0%, 100%": { boxShadow: "0 0 0 0 rgba(255,255,255,0.55)" },
              "50%": { boxShadow: "0 0 0 9px rgba(255,255,255,0)" },
            },
            animation: "aiButtonGlow 2s ease-in-out infinite",
            "&:hover": { backgroundColor: "#f5f5f5" },
          }}
        >
          Yapay Zeka ile Eşleştir
        </Button>
      </Box>

      {/* Kategori Arama Formu */}
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: { xs: 2, sm: 3 },
          borderRadius: 2,
          boxShadow: 2,
          marginBottom: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <TextField
            size="small"
            label="Kategori Ara"
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Kategori ara"
          />
          <TextField
            select
            size="small"
            label="Eşleşme Yapılmayan Pazaryeri"
            variant="outlined"
            value={selectedPlace}
            onChange={(e) => setSelectedPlace(e.target.value)}
            sx={{
              minWidth: { xs: "100%", sm: 200 },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <MenuItem value={null}>Seç</MenuItem>
            {allPlaces.map((place) => (
              <MenuItem key={place.id} value={place}>
                {place.name}
              </MenuItem>
            ))}
          </TextField>
          <Button
            variant="contained"
            onClick={handleFilter}
            sx={{
              borderRadius: 2,
              width: { xs: "100%", sm: "auto" },
            }}
          >
            Ara
          </Button>
        </Box>
      </Box>

      {/* Yapay Zeka ile Toplu Kategori Eşleştirme Modalı */}
      <Dialog
        open={aiModalOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          handleCloseAiModal();
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2, overflow: "hidden" } }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1.5,
            px: 3,
            py: 2,
            background: "linear-gradient(135deg, #1565c0 0%, #1e88e5 100%)",
            color: "#fff",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <AutoAwesomeIcon sx={{ fontSize: 26 }} />
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                Yapay Zeka ile Kategori Eşleştir
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                {aiModalPlace?.name ?? "Pazaryeri seçilmedi"}
              </Typography>
            </Box>
          </Box>
          <IconButton
            size="small"
            onClick={handleCloseAiModal}
            disabled={aiMatching}
            sx={{ color: "#fff" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Box sx={{ px: 3, pt: 2.5, pb: 1, backgroundColor: "#fafbfc" }}>
          <Stepper
            activeStep={{ select: 0, preview: 1, running: 2, done: 3 }[aiModalStep]}
            alternativeLabel
          >
            {["Pazaryeri Seç", "Önizleme & Onay", "Eşleştiriliyor", "Sonuç"].map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        <DialogContent dividers sx={{ backgroundColor: "#fafbfc" }}>
          {aiModalStep === "select" && (
            <Box
              sx={{
                backgroundColor: "#fff",
                border: "1px solid #e6e8ec",
                borderRadius: 2,
                p: 2.5,
              }}
            >
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Eşleşmemiş kategorilerini otomatik eşleştirmek istediğiniz pazaryerini seçin.
              </Typography>
              <TextField
                select
                fullWidth
                size="small"
                label="Pazaryeri"
                value={aiModalPlace ?? ""}
                onChange={(e) => setAiModalPlace(e.target.value)}
              >
                {allPlaces.map((place) => (
                  <MenuItem key={`${place.type}-${place.id}`} value={place}>
                    {place.name}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          )}

          {aiModalStep === "preview" && (
            <Box>
              {aiSummary?.error ? (
                <Alert severity="error">Eşleşmemiş kategoriler alınırken hata oluştu.</Alert>
              ) : aiUnmatchedList.length === 0 ? (
                <Alert severity="info">
                  {aiModalPlace?.name} için eşleşmemiş kategori bulunamadı.
                </Alert>
              ) : (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      backgroundColor: "#fff",
                      border: "1px solid #e6e8ec",
                      borderRadius: 2,
                      px: 2,
                      py: 1.25,
                      mb: 2,
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                      {aiModalPlace?.name} için eşleşmemiş {aiUnmatchedList.length} kategori
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 700,
                        color: "#1565c0",
                        backgroundColor: "#e3f2fd",
                        borderRadius: 5,
                        px: 1.25,
                        py: 0.5,
                      }}
                    >
                      {aiSelectedIds.length} seçili
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      maxHeight: 300,
                      overflowY: "auto",
                      backgroundColor: "#fff",
                      border: "1px solid #e6e8ec",
                      borderRadius: 2,
                      mb: 2,
                    }}
                  >
                    <List dense disablePadding>
                      <ListItem
                        divider
                        sx={{ backgroundColor: "#f0f6fd", borderColor: "#e6e8ec" }}
                      >
                        <FormControlLabel
                          sx={{ ml: 0 }}
                          control={
                            <Checkbox
                              checked={aiSelectedIds.length === aiUnmatchedList.length}
                              indeterminate={
                                aiSelectedIds.length > 0 &&
                                aiSelectedIds.length < aiUnmatchedList.length
                              }
                              onChange={handleToggleAiSelectAll}
                            />
                          }
                          label={<Typography sx={{ fontWeight: 600 }}>Tümünü Seç</Typography>}
                        />
                      </ListItem>
                      {aiUnmatchedList.map((category) => (
                        <ListItem key={category.id} divider sx={{ borderColor: "#f0f1f3" }}>
                          <FormControlLabel
                            sx={{ ml: 0, width: "100%" }}
                            control={
                              <Checkbox
                                checked={aiSelectedIds.includes(category.id)}
                                onChange={() => handleToggleAiCategory(category.id)}
                              />
                            }
                            label={category.name}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                  <Alert severity="warning" variant="outlined" sx={{ mb: 1.5, borderRadius: 2 }}>
                    Bu işlem listedeki her kategori için yapay zeka servisine ayrı bir istek
                    gönderir ve kullanılan yapay zeka servisine göre ücrete tabi olabilir.
                    Eşleştirme sonucu her zaman doğru olmayabilir, kaydedilen eşleşmeleri kontrol
                    etmenizi öneririz.
                  </Alert>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={aiConsentChecked}
                        onChange={(e) => setAiConsentChecked(e.target.checked)}
                      />
                    }
                    label="Okudum, yukarıdaki kategorilerin yapay zeka ile eşleştirilmesini onaylıyorum."
                  />
                </>
              )}
            </Box>
          )}

          {aiModalStep === "running" && (
            <Box
              sx={{
                backgroundColor: "#fff",
                border: "1px solid #e6e8ec",
                borderRadius: 2,
                p: 3,
                textAlign: "center",
              }}
            >
              <AutoAwesomeIcon
                sx={{
                  fontSize: 32,
                  color: "#1565c0",
                  mb: 1,
                  "@keyframes aiRunningPulse": {
                    "0%, 100%": { opacity: 1, transform: "scale(1)" },
                    "50%": { opacity: 0.55, transform: "scale(1.15)" },
                  },
                  animation: "aiRunningPulse 1.4s ease-in-out infinite",
                }}
              />
              <Typography variant="body2" sx={{ mb: 2 }}>
                {aiModalPlace?.name} için kategoriler eşleştiriliyor, lütfen bekleyin...
              </Typography>
              <LinearProgress
                variant="determinate"
                value={
                  aiProgress.total > 0
                    ? Math.round((aiProgress.current / aiProgress.total) * 100)
                    : 0
                }
                sx={{ height: 8, borderRadius: 5 }}
              />
              <Typography variant="body2" sx={{ mt: 1.5, fontWeight: 600 }}>
                {aiProgress.current}/{aiProgress.total} kategori işlendi (%
                {aiProgress.total > 0
                  ? Math.round((aiProgress.current / aiProgress.total) * 100)
                  : 0}
                )
              </Typography>
            </Box>
          )}

          {aiModalStep === "done" && (
            <Alert severity={aiSummary?.error ? "error" : "success"} sx={{ borderRadius: 2 }}>
              {aiSummary?.error
                ? "AI toplu eşleştirme sırasında hata oluştu."
                : `Tamamlandı: ${aiSummary?.matched} kategori eşleştirildi, ${aiSummary?.failed} kategori için uygun eşleşme bulunamadı (toplam ${aiSummary?.total}).`}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2, backgroundColor: "#fafbfc" }}>
          {aiModalStep === "select" && (
            <>
              <Button onClick={handleCloseAiModal}>Vazgeç</Button>
              <Button
                variant="contained"
                color="primary"
                disabled={!aiModalPlace?.id || aiPreviewLoading}
                onClick={handleAiModalPlaceNext}
                startIcon={
                  aiPreviewLoading ? <CircularProgress size={16} color="inherit" /> : null
                }
              >
                Devam Et
              </Button>
            </>
          )}

          {aiModalStep === "preview" && (
            <>
              <Button onClick={() => setAiModalStep("select")}>Geri</Button>
              <Button onClick={handleCloseAiModal}>Vazgeç</Button>
              {aiUnmatchedList.length > 0 && !aiSummary?.error && (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!aiConsentChecked || aiSelectedIds.length === 0}
                  onClick={handleAiMatchRun}
                >
                  Eşleştir{aiSelectedIds.length > 0 ? ` (${aiSelectedIds.length})` : ""}
                </Button>
              )}
            </>
          )}

          {aiModalStep === "running" && <Button disabled>Eşleştiriliyor...</Button>}

          {aiModalStep === "done" && (
            <Button variant="contained" color="primary" onClick={handleCloseAiModal}>
              Kapat
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Kategori Listeleme */}
      {renderCategories(filteredCategories)}

      <Dialog open={openDeleteDialog} onClose={handleDeleteDialogClose}>
        <DialogTitle>Silme Onayı</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Bu kategoriyi silmek, tüm alt kategorileri ve bağlantılı ürünleri de
            silecektir. Silmek istediğinizden emin misiniz ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            İptal
          </Button>
          <Button onClick={handleDelete} color="error">
            Evet, Sil
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDeleteErrorModal}
        onClose={() => setOpenDeleteErrorModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ pb: 0 }}>Kategori Silinemiyor</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Alert
            severity="error"
            variant="filled"
            sx={{
              "& .MuiAlert-message": { width: "100%" },
            }}
          >
            İlgili kategoriye bağlı alt kategori veya ürün bulunmaktadır. Öncesinde
            bunların silinmesi veya taşınması gerekmektedir.
          </Alert>
        </DialogContent>
        <DialogActions sx={{ pt: 2, px: 3, pb: 2 }}>
          <Button
            onClick={() => setOpenDeleteErrorModal(false)}
            variant="contained"
            color="primary"
          >
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      <CategoryUpdate
        openDialog={openDialogUpdate}
        handleCloseDialog={() => setOpenDialogUpdate(false)}
        data={selectedCategoryForEdit}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
          marginTop: 2,
          flexWrap: "wrap",
        }}
      >
        <TextField
          select
          size="small"
          label="Sayfa başına"
          value={pageSize}
          onChange={handlePageSizeChange}
          sx={{ minWidth: 130 }}
        >
          {[10, 25, 50, 100].map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </TextField>

        <Button
          variant="outlined"
          disabled={page === 1}
          onClick={() => setPage((prev) => prev - 1)}
        >
          Geri
        </Button>

        {/* Current Page / Total Pages */}
        <Typography variant="body1" component="span">
          Sayfa {page} / {totalPages}
        </Typography>

        <Button
          variant="contained"
          disabled={page >= totalPages}
          onClick={() => setPage((prev) => prev + 1)}
        >
          İleri
        </Button>
      </Box>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Dialog
        open={importResultModal}
        onClose={() => setImportResultModal(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { minWidth: 400 } }}
      >
        <DialogTitle>{importResult.success ? "Başarılı" : "Hata"}</DialogTitle>
        <DialogContent>
          <Typography variant="body1">{importResult.message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setImportResultModal(false)}
            variant="contained"
            color={importResult.success ? "success" : "error"}
          >
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      {/* Import Modal */}
      <Dialog
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            width: { xs: "95%", sm: "auto" },
            margin: { xs: 1, sm: "auto" },
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            fontSize: { xs: "1.1rem", sm: "1.25rem" },
          }}
        >
          Kategori İçeri Aktarma
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>E-ticaret Platformu</InputLabel>
              <Select
                value={selectedEcommerce}
                onChange={(e) => setSelectedEcommerce(e.target.value)}
                label="E-ticaret Platformu"
              >
                {ecommerceList.map((place) => (
                  <MenuItem key={place.id} value={place.id}>
                    {place.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>KDV Oranı</InputLabel>
              <Select
                value={selectedVatRate}
                onChange={(e) => setSelectedVatRate(e.target.value)}
                label="KDV Oranı"
              >
                {vatRates.map((rate) => (
                  <MenuItem key={rate} value={rate}>
                    %{rate}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            p: 2,
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 0 },
          }}
        >
          <Button
            onClick={() => setImportModalOpen(false)}
            variant="outlined"
            fullWidth={false}
            sx={{
              borderRadius: 2,
              borderColor: "#1F1B45",
              color: "#1F1B45",
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                borderColor: "#2C285A",
                backgroundColor: "#F3F3F3",
              },
            }}
          >
            İptal
          </Button>
          <Button
            onClick={handleImport}
            variant="contained"
            disabled={importLoading}
            fullWidth={false}
            sx={{
              borderRadius: 2,
              backgroundColor: "#1F1B45",
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                backgroundColor: "#2C285A",
              },
            }}
          >
            {importLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "İçeri Aktar"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <CategoryProductEdithModal
        open={openProductCategoryModal}
        handleClose={handleCloseProductCategoryModal}
        category={modalCategory}
      />
      {/* Modal Bileşeni */}
      <CategoryMatchingModal
        open={openModal}
        handleClose={handleCloseModal}
        category={modalCategory}
      />
    </Box>
  );
};
